import { conditionTypes, dataTypes, conditionTypeOperators } from './constants';

export default (conditions = []) => ({
  getConditionType: (conditionAttribute) =>
    conditions.find((c) => c.key === conditionAttribute).dataType,

  getDataFrameConditionType: (dataFrameAttribute, conditionAttribute) =>
    conditions
      .find((c) => c.key === dataFrameAttribute)
      ?.subAttribute?.attributes.find(
        (a) => a.conditionAttribute === conditionAttribute
      )?.conditionAttributeType || 'Integer',

  getDataFrameAttributes: (conditionAttribute) => {
    return {
      attributes: [
        ...conditions
          .find((c) => c.key === conditionAttribute)
          ?.subAttribute?.attributes.filter((f) => !f.metaAttribute),
        {
          displayName: 'Dataframe Count',
          conditionAttribute: 'dataframeCount',
          conditionAttributeType: 'Integer'
        }
      ]
    };
  },

  conditionIsString: (conditionAttribute) =>
    conditionAttribute === dataTypes.STRING,

  conditionIsInteger: (conditionAttribute) =>
    conditionAttribute === dataTypes.INTEGER,

  conditionIsDouble: (conditionAttribute) =>
    conditionAttribute === dataTypes.DOUBLE,

  conditionIsDate: (conditionAttribute) =>
    conditionAttribute === dataTypes.DATE,

  conditionIsDateTime: (conditionAttribute) =>
    conditionAttribute === dataTypes.DATE_TIME,

  conditionIsBigDecimal: (conditionAttribute) =>
    conditionAttribute === dataTypes.BIGDECIMAL,

  conditionIsBoolean: (conditionAttribute) =>
    conditionAttribute === dataTypes.BOOLEAN,

  conditionIsLong: (conditionAttribute) =>
    conditionAttribute === dataTypes.LONG,

  filterOperatorsByCondition: (dataFrameAttribute, conditionAttribute) => {
    let conditionType;
    if (dataFrameAttribute) {
      conditionType =
        conditions
          .find((c) => c.key === dataFrameAttribute)
          ?.subAttribute?.attributes.find(
            (a) => a.conditionAttribute === conditionAttribute
          )?.conditionAttributeType || 'Count Operator';
    } else {
      conditionType = conditions.find(
        (c) => c.key === conditionAttribute
      )?.dataType;
    }
    let filteredTypes = conditionTypes.filter((t) =>
      t.appliesTo.includes(conditionType)
    );
    // Special case
    if (conditionAttribute === 'GUEST_ACTIVITY_DATA_businessContextId') {
      return filteredTypes.filter(
        (t) =>
          t.type === conditionTypeOperators.EQUALS ||
          t.type === conditionTypeOperators.DOES_NOT_EQUAL
      );
    }

    return conditionTypes.filter((t) => t.appliesTo.includes(conditionType));
  }
});
